export enum PurchaseOrderStatus {
  PENDING = "PENDING",
  PLACED = "PLACED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}
